module.exports = __webpack_public_path__ + "media/customizations/eaglecreek/logo-d18e706b48e0174e480222c6439e8ba3.png";